/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseTaskSubmissionVersionDetailData } from './genericApiResponseTaskSubmissionVersionDetailData';
import type { GenericApiResponseTaskSubmissionVersionDetailMessage } from './genericApiResponseTaskSubmissionVersionDetailMessage';
import type { GenericApiResponseTaskSubmissionVersionDetailPagination } from './genericApiResponseTaskSubmissionVersionDetailPagination';
import type { GenericApiResponseTaskSubmissionVersionDetailError } from './genericApiResponseTaskSubmissionVersionDetailError';

export interface GenericApiResponseTaskSubmissionVersionDetail {
  data?: GenericApiResponseTaskSubmissionVersionDetailData;
  message?: GenericApiResponseTaskSubmissionVersionDetailMessage;
  pagination?: GenericApiResponseTaskSubmissionVersionDetailPagination;
  error?: GenericApiResponseTaskSubmissionVersionDetailError;
  statusCode?: number;
}
